import Vue from 'vue'
import Vuex from 'vuex'
// import indexedDBPlugin from ''

import Consultation from './modules/clinique/consultations'
import GlobalVar from '../store/modules/globalVariables'
import Patient from './modules/clinique/patients'
import Analyse from './modules/clinique/analyses'
import Examens from './modules/clinique/examens'
import Assurances from './modules/clinique/assurances'
import Operations from './modules/comptabilite/operation'
import Compte from './modules/comptabilite/compte'
import SoinsHospitalisation from './modules/clinique/soin_hospitalisation'
import Produits from './modules/stock/produits'
import createPersistedState from "vuex-persistedstate"
import auth from './modules/auth'
import Prescription from './modules/clinique/prescriptions'
import Exploitations from './modules/comptabilite/exploitations'
import Config from './modules/config/config'
import Comptable from './modules/comptabilite/comptable'
import Depot from './modules/comptabilite/depot'
import Proforma from './modules/comptabilite/proforma'
import Prestation from './modules/clinique/prestation'
import Configs from './modules/comptabilite/configs'
import RapportCaisse from './modules/comptabilite/rapport-caisse'
import FileAttente from './modules/clinique/file-attente'
import Remunerations from './modules/clinique/remunerations'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Consultation, GlobalVar, Patient,
        Analyse, Examens, Assurances,
        Operations, Compte, SoinsHospitalisation,
        Produits, auth, Prescription, Exploitations,
        Config, Comptable, Depot, Proforma, Prestation,
        Configs, RapportCaisse, FileAttente, Remunerations
    },
    plugins: [createPersistedState()]
})
